export default __webpack_public_path__ + "static/media/decision_making_air_table.6d6d7029.png";